/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { HpeInitType } from '@gh/builder-shared-data';
import { AppFormControl, FormState, FormStateBuilder } from '@gh/common-shared';
import { AutocompleteLoadMoreEvent, DialogInput, getControl } from '@gh/core-ui';
import {
  HousePlanEstimateCreateDialogConfig,
  HousePlanEstimateDetailsBusinessService,
} from '../../resources/house-plan-estimate-details-business.service';
import { HpeCreateDetails, hpeDetailsInitFromCreate } from '../../resources/hpe-details.model';

@Component({
  selector: 'gh-house-plan-estimate-create-dialog',
  template: require('./house-plan-estimate-create-dialog.component.html'),
  styles: [require('./house-plan-estimate-create-dialog.component.scss')],
})
export class HousePlanEstimateCreateDialogComponent implements OnInit,
                                                               DialogInput<HousePlanEstimateCreateDialogConfig> {
  input: HousePlanEstimateCreateDialogConfig;
  form: FormState<HpeCreateDetails>;

  constructor(private dialogRef: MatDialogRef<any>,
              private formStateBuilder: FormStateBuilder,
              private businessService: HousePlanEstimateDetailsBusinessService) {

  }

  ngOnInit(): void {
    this.form = this.formStateBuilder.buildPlain<HpeCreateDetails>({
      value: {
        housePlanId: this.input.housePlanId,
        initType: HpeInitType.FromScratch,
        sourceHousePlanId: void 0,
        sourceJob: void 0,
      },
      children: {
        housePlanId: void 0,
        initType: void 0,
        sourceHousePlanId: { enabled: false },
        sourceJob: { visible: this.input.isCloneFromJobAllowed, enabled: false },
      },
    });
  }

  onSubmit(): void {
    const { form } = this;
    if (form.group.invalid) {
      form.markAllAsTouched();
    } else {
      this.dialogRef.close(hpeDetailsInitFromCreate(this.form.submitValue));
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onTypeChange(type: HpeInitType): void {
    const housePlanControl = <AppFormControl>getControl(this.form.group, 'sourceHousePlanId');
    const jobControl = <AppFormControl>getControl(this.form.group, 'sourceJob');
    switch (type) {
      case HpeInitType.CloneFromHousePlan:
        housePlanControl.updateSchema({ required: true, enabled: true });
        jobControl.updateSchema({ required: false, enabled: false });
        break;
      case HpeInitType.CloneFromJob:
        jobControl.updateSchema({ required: true, enabled: true });
        housePlanControl.updateSchema({ required: false, enabled: false });
        break;
      case HpeInitType.FromScratch:
      case HpeInitType.CopyCostCenters:
        jobControl.updateSchema({ required: false, enabled: false });
        housePlanControl.updateSchema({ required: false, enabled: false });
        break;
      default:
        break;
    }
  }

  loadMoreHousePlans(event: AutocompleteLoadMoreEvent): void {
    event.load(this.businessService.loadHousePlans(
      {
        salesEstimate: this.input.useSalesEstimates,
        hideEmpty: true,
      },
      event.query));
  }

  loadMoreJobs(event: AutocompleteLoadMoreEvent): void {
    event.load(this.businessService.loadJobs(event.query));
  }
}
